<template>
    <section class="section">
        <div class="container">
            <div class="columns is-multiline is-vcentered">
                <div v-for="product in productList" v-bind:key="product.id" class="column is-3">
                    <ProductCard :name="product.name" :description="product.description" :idProducto="product.id" :price="product.price" @addToCart="addToShoppingCart"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions } from "vuex"

import ProductCard from '@/components/ProductCard.vue'

export default {
    name: 'ProductsList',
    components: {
        ProductCard
    },
    props: ["productList"],
    methods: {
        ...mapActions(["addItem"]),
        addToShoppingCart(id) {
            var selectedItem = this.productList.filter(function(item) {
                return item.id == id
            })
            this.addItem(selectedItem[0])
        }
    }
}
</script>

<style>

</style>